import {Loader} from '@googlemaps/js-api-loader';
import {mapStyles} from "../lib/google-maps-styles";

const module = {};
const MAPS_API_KEY = "AIzaSyDCcNOSIlVl0FXSu6tJ6sXhpv9TnwIxGTk";

/**
 * Container Initialization
 */
module.init = function () {
	const loader = new Loader({
		apiKey: MAPS_API_KEY,
		version: "weekly"
	})

	if (googleMapIframe.startsWith('<iframe') && googleMapIframe.endsWith('</iframe>')) {
		EmbedGoogleMapIframe();
	} else {
		loader.load().then(module.initMap);
	}
};

module.initMap = async () => {
	const { Map } = await google.maps.importLibrary("maps");
	// This is just the center point of the US. Once the markers are loaded, we'll rezoom the map to fit the marker bounds
	let latitude = 39.8283;
	let longitude = -98.5795;

	const map = new Map(document.getElementById('locations-map'), {
		zoom: 4,
		center: {
			lat: latitude,
			lng: longitude
		},
		maxZoom: 8,
		styles: mapStyles,
		gestureHandling: 'cooperative',
		mapTypeId: google.maps.MapTypeId.ROADMAP
	});

	const bounds = new google.maps.LatLngBounds();
	const infoWindows = [];

	for (let city of cities) {
		const marker = module.addMarker(map, city);
		const infoWindow = module.addInfoWindow(city);
		infoWindows.push(infoWindow);
		marker.addListener("click", () => {
			module.closeInfoWindows(infoWindows);
			infoWindow.open({
				anchor: marker,
				map,
			});
		});
		bounds.extend(new google.maps.LatLng(city.lat, city.lng));

		if ( radius ){
			module.addCircle(map, marker);
		}
	}
	map.fitBounds(bounds, 50);
};

module.addMarker = (map, data) => {
	const marker = new google.maps.Marker({
		map: map,
		position: new google.maps.LatLng(data.lat, data.lng),
		title: `${data.city}, ${data.state}`,
		icon: {
			url: '/wp-content/themes/erie-child/dist/images/map-marker.png',
			scaledSize: new google.maps.Size(35, 43.75)
		}
	});

	return marker;
}

module.addCircle = (map, marker) => {
	var circle = new google.maps.Circle({
		map: map,
		radius: radius,    // 16093 = 10 miles in metres
		fillColor: '#c1101d',
		strokeColor: '#c1101d'
	});
	circle.bindTo('center', marker, 'position');
}

module.addInfoWindow = (data) => {

	let locUrl;
	let ctaText;
	let ctaTarget;
	const locName = `${data.name}`;

	if ( directions === true ){
		locUrl = `https://www.google.com/maps?daddr=${data.address} ${data.city} ${data.state}`;
		ctaText = `Get Directions`;
		ctaTarget = `_blank`;
	} else {
		locUrl = '/locations/'+data.service+'/' + data.slug+'';
		ctaText = `View Location Details`;
		ctaTarget = `_self`;
	}

	const contentString = ` <div class="location-popup wp-block-buttons">
		<div class="h4 location-popup__title">${locName}</div>
		<div class="location-popup__address">
			${data.address}<br />
			${data.city}, ${data.state} ${data.zip}
		</div>
		<div class="wp-block-button location-popup__btn is-style-fill">
			<a href="${locUrl}" target="${ctaTarget}" class="wp-block-button__link wp-element-button">${ctaText}</a>
		</div>
	</div>`;

	const infoWindow = new google.maps.InfoWindow({
		content: contentString,
		ariaLabel: `Details for ${locName}`,
	});

	return infoWindow;
}

module.closeInfoWindows = (windows) => {
	for (let window of windows) {
		window.close();
	}
}

document.addEventListener("DOMContentLoaded", () => {
    module.init();
    setBackgroundImageIfTestimonialExists();
});

// Define a function to set the background image
function setBackgroundImageIfTestimonialExists() {
    // Select the container div with the class "wp-block-uagb-container"
    const container = document.querySelector(".testimonial-container");
    // Check if the container and the "testimonial-roofing" div exist within it
    if (container && container.querySelector(".testimonial-basement-solutions")) {
        // Set the background image for the container div
        container.style.backgroundImage = "url('/wp-content/uploads/2024/11/Basement-Testimonial-Background.jpg')";
    }
}

// Define a function to embed the Google Map from the IFrame provided in MPG file.
function EmbedGoogleMapIframe () {
    // Get the div by its ID
	const locationsMapDiv = document.getElementById('locations-map');
    if (locationsMapDiv) {
		// Set the iframe as the innerHTML of the div
		locationsMapDiv.innerHTML = googleMapIframe;
    }
}